import React from "react";
import styles from "./ChooseTimePanel.style";
import {Panel, PanelHeader, PanelHeaderBack} from "@vkontakte/vkui";
import {connect} from "react-redux";
import { setPreviousPanel } from "../../redux/actions/panelsActions";
import {panels} from "../../variables";
import TimeTable from "./TimeTable";

const ChooseTimePanel = ({
                             id,
                             goBack,
                             slots, selectedDay
                         }) => {

    const getAvailableSlots = (slots) => {
        const availableSlots = [];
        for(let i = 0; i< slots.length; i++){
            const newDate = new Date(slots[i].visitTime);
            if(newDate.getDate() === selectedDay){
                availableSlots.push(slots[i])
            }
        }
        return availableSlots;
    }

    return (
        <Panel id={id}>
            <PanelHeader
                left={<PanelHeaderBack onClick={() => goBack()}/>}>
                <span style={styles.blue}>ГОС</span><span style={styles.red}>УСЛУГИ</span>
            </PanelHeader>
            <TimeTable slots={getAvailableSlots(slots)}/>
        </Panel>
    )
}

const mapStateToProps = (state) => {
    return {
        slots: state.dates.slots,
        selectedDay: state.dates.selectedDay,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        goBack: () => dispatch(setPreviousPanel())
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ChooseTimePanel);
